import { MapPin, Phone, Clock } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { ConsultationForm } from "@/components/ConsultationForm";
import { usePageMeta } from "@/hooks/usePageMeta";
import { BUSINESS } from "@/lib/constants";

export default function ContactPage() {
  usePageMeta(
    "Contact J11 Consulting | Credit Education & Mentorship",
    "Contact J11 Consulting LLC in Palm Bay, Florida. Request a free consultation or call (800) 505-1628."
  );

  return (
    <PageLayout
      eyebrow="Contact"
      title={`Talk With ${BUSINESS.shortName}`}
      subtitle="Request a free consultation and tell us what you would like help understanding."
      testId="contact-page"
    >
      <section className="bg-[#141419] py-14 lg:py-20">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-5 lg:gap-16 lg:px-8">
          <div className="lg:col-span-2">
            <Reveal>
              <div className="space-y-6">
                <div className="flex items-start gap-4" data-testid="contact-address-block">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#17171C] shadow-sm">
                    <MapPin className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-[#F2EEE3]">{BUSINESS.name}</p>
                    <p className="mt-1 text-sm leading-relaxed text-[#B8B2A6]">
                      195 Malabar Rd, Suite #3
                      <br />
                      Palm Bay, FL 32907
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-testid="contact-phone-block">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#17171C] shadow-sm">
                    <Phone className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-[#F2EEE3]">Phone</p>
                    <a
                      href={BUSINESS.phoneHref}
                      data-testid="contact-phone-link"
                      className="mt-1 block text-sm font-semibold text-[#D8B54A] transition-colors duration-200 hover:text-[#E4C463]"
                    >
                      {BUSINESS.phone}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-testid="contact-response-block">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#17171C] shadow-sm">
                    <Clock className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-[#F2EEE3]">Consultations</p>
                    <p className="mt-1 text-sm leading-relaxed text-[#B8B2A6]">
                      Request a consultation and our team will follow up with you regarding your
                      inquiry.
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-3">
            <ConsultationForm source="contact-page-form" />
          </Reveal>
        </div>
      </section>
    </PageLayout>
  );
}
